import React from "react";
import ServicesListing from "./ServicesListing";
import TripleStackServicesListing from "./TripleStackServicesListing";
import CleanGridServicesListing from "./CleanGridServicesListing";
import BoxDuoServicesListing from "./BoxDuoServicesListing";
import MasonryShowcaseServicesListing from "./MasonryShowcaseServicesListing";
import TimeLineServicesListing from "./TimeLineServicesListing";
import { useSelector } from "react-redux";
import SimpleInfoBoxServicesListing from "./SimpleInfoBoxServicesListing";

function ServicesPageWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>
      {sitedata?.theme_specialities === "card-triple-stack" ? (
        <TripleStackServicesListing />
      ) : sitedata?.theme_specialities === "clean-grid-gallery" ? (
        <CleanGridServicesListing />
      ) : sitedata?.theme_specialities === "masonry-showcase" ? (
        <MasonryShowcaseServicesListing />
      ) : sitedata?.theme_specialities === "info-box-duo" ? (
        <BoxDuoServicesListing />
      ) : sitedata?.theme_specialities === "time-line" ? (
        <TimeLineServicesListing />
      ) : sitedata?.theme_specialities === "simple-info-box" ? (
        <SimpleInfoBoxServicesListing />
      ) : (
        <ServicesListing />
      )}

     {/* <MasonryShowcaseServicesListing /> */}
      

    </>
  );
}

export default ServicesPageWrapper;
